import { useLogin } from '@/providers/login/LoginProvider';
import { withFlowComponent } from '@/HOC/withFlowComponent';
import {
  PRIME_FIRST_PHASE_2_DESKTOP,
  primeFreezeVersionedComponentDesktop,
  primeFreezeVersionedComponentMobile,
} from '@/versionedComponents';
import { createFeature } from '@edreamsodigeo/frontend-core';

export const EntryPointPrimeFirstPhase2 = LoadedUserCheck;

export const EntryPointPrimeFirstPhase2Desktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [PrimeCheckEntrypointComponent, LoadedUserCheck, LoadedUserCheck],
  version: 1,
});

function LoadedUserCheck({ children }) {
  const { isLoading } = useLogin();

  if (isLoading) {
    return null;
  }

  return children;
}

function PrimeCheckEntrypointComponent({ children }) {
  const { isLoading, isPrime } = useLogin();

  if (!isLoading && !isPrime) {
    return null;
  }

  return children;
}

function PrimeCheckFunnelComponent({ children }) {
  const { isLoading, isPrime } = useLogin();

  if (!isLoading && !isPrime) {
    throw new Error('Not a prime user');
  }

  return children;
}

function EmptyProvider({ children }) {
  return children;
}

const primeFreezeFunnelFactory = [
  PrimeCheckFunnelComponent,
  EmptyProvider,
  EmptyProvider,
  EmptyProvider,
];

export const PrimeCheckFunnel = withFlowComponent(
  primeFreezeVersionedComponentMobile(primeFreezeFunnelFactory),
  primeFreezeVersionedComponentDesktop(primeFreezeFunnelFactory)
);

export const PrimeCheckEntrypoint = withFlowComponent(
  EntryPointPrimeFirstPhase2,
  EntryPointPrimeFirstPhase2Desktop
);
